module.exports = __webpack_public_path__ + "static/3-Tri-11-b29bd3a38f0560230278f808b7786a75.png";